import { render, staticRenderFns } from "./Promocoes.vue?vue&type=template&id=b4511cac&scoped=true"
import script from "./Promocoes.vue?vue&type=script&lang=js"
export * from "./Promocoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4511cac",
  null
  
)

export default component.exports